module.exports = __webpack_public_path__ + "static/media/profile.2e65e280.png";